//import "babel-polyfill";
//import 'core-js/modules/es6.object.assign';
import Widget from './widget';

window.rcWidget = Widget;


// WEBPACK FOOTER //
// ./_static/js/index.js